import { API } from "aws-amplify";
import { getBuilding } from "~/graphql/queries";
import * as APITypes from "../../../../API";

export const EMPTY_BUILDING: APITypes.Building = {
  id: "",
  street: "",
  userID: "",
  name: "",
  propertyID: "",
  price: null,
  numBedroom: "",
  numBathroom: "",
  status: APITypes.BuildingStatusType.None,
  type: APITypes.BuildingType.Multiple,
  size: "",
  contact: "",
  description: "",
  actualRentPaymentDate: "",
  __typename: "Building",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getBuildingDetails = async (buildingID: String) => {
  try {
    const response = (await API.graphql({
      query: getBuilding,
      variables: {
        id: buildingID,
      },
    })) as { data?: APITypes.GetBuildingQuery };

    return {
      success: true,
      data: response.data?.getBuilding || EMPTY_BUILDING,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_BUILDING,
      error,
    };
  }
};
